// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1sC1i","info":"Note_info__R5Exu","note":"Note_note__3cMNm","actions":"Note_actions__wKnK4"};